import './polyfills';
import './sentry';

import './jquery';
import 'jquery-ui/dist/jquery-ui';
import './libs/jquery-svg/jquery.svg';

import './select2';
import 'select2/dist/js/i18n/de';

import './jquery/plugins';
import './bootstrap';
import './socket';

import _ from 'underscore';
import Backbone from 'backbone';

window._ = _;
window.Backbone = Backbone;
